














































































































































































































































































































































































































































































import Api from "@/api/api";
import moment from "moment";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      filtraClientiPerProduttore: null,
      filtraClientiPerUtente: null,
      customerId: undefined as any,
      totalRows: 0,
      page: 0,
      openCheckAllDocumentsModal: false,
      loading: false,
      loaded: false,
      dataUploadDa: null,
      dataUploadA: null,
      dataCopliantDa: null,
      dataCopliantA: null,
      ToggleButtonCompliant: false,
      ToggleButtonNonCompliant: false,
      toggleButtonInAttesa: false,
      toggleButtonSubProducers: true,
      toggleButtonDocumentiAutoApprovati: false,
      filter: "",
      filterInput: "",
      timerSearch: 0,
      numeroFiltri: 0,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
        filter: undefined
      },
      columns: [
        {
          name: "description",
          required: true,
          label: "Ragione Sociale",
          align: "left",
          field: (row: any) => row.description,
          format: (val: any) => `${val}`,
          sortable: true
        },
        {
          name: "address",
          align: "left",
          label: "Indirizzo",
          field: (row: any) =>
            (
              row.toponym +
              " " +
              row.address +
              row.civic_number +
              ", " +
              row.cap +
              " " +
              row.province
            ).toUpperCase(),
          sortable: true
        },
        {
          name: "fiscal_code_piva",
          align: "left",
          label: "Codice Fiscale / P.IVA",
          field: (row: any) =>
            (
              row.fiscal_code + (row.piva != null ? " /" + row.piva : "")
            ).toUpperCase(),
          sortable: true
        },
        {
          name: "producer_code",
          align: "left",
          label: "Produttore",
          field: "producer_code"
        },
        {
          name: "compliance_date",
          align: "left",
          label: "Data Compliance",
          field: (row: any) =>
            row.compliance_date != null
              ? moment(String(row.compliance_date)).format("DD/MM/YYYY")
              : ""
        },
        {
          name: "status",
          align: "left",
          label: "Stato",
          sortable: false,
          field: () => ""
        } /* ,
      {
        name: "actions",
        align: "left",
        label: "Azioni",
        field: "",
        sortable: false
      } */
      ],
      data: [],
      dataSelectUsers: [] as any,
      dataSelectProduttori: [] as any,
      dataSelectProduttoriFiltered: [] as any,
      dataSelectUsersFiltered: [] as any,
      isShow: false,
      intervalId: 0,
      key: "",
      timerStopped: false
    };
  },
  mounted() {
    this.getData({
      pagination: this.pagination,
      filter: undefined
    });
    this.getCustomerDescription();
    this.getUsers();
  },
  methods: {
    getNumberFilter() {
      this.numeroFiltri = 0;
      if (this.dataUploadDa != null) {
        this.numeroFiltri++;
      }
      if (this.dataUploadA != null) {
        this.numeroFiltri++;
      }
      if (this.dataCopliantDa != null) {
        this.numeroFiltri++;
      }
      if (this.dataCopliantA != null) {
        this.numeroFiltri++;
      }
      if (this.ToggleButtonCompliant !== false) {
        this.numeroFiltri++;
      }
      if (this.ToggleButtonNonCompliant !== false) {
        this.numeroFiltri++;
      }
      if (this.toggleButtonInAttesa !== false) {
        this.numeroFiltri++;
      }
      if (this.toggleButtonDocumentiAutoApprovati !== false) {
        this.numeroFiltri++;
      }
      if (this.filtraClientiPerUtente != null) {
        this.numeroFiltri++;
      }
      if (this.filtraClientiPerProduttore != null) {
        this.numeroFiltri++;
      }
    },

    restartTimer() {
      this.timerSearch = 0;
    },

    stopTimer() {
      this.timerSearch = 0;
      clearInterval(this.intervalId);
    },

    changeProgress() {
      if (!(this.timerSearch >= 100)) {
        this.timerSearch = this.timerSearch + 0.3;
      } else {
        this.stopTimer();
        this.getData({
          pagination: this.pagination,
          filter: undefined
        });
      }
    },

    getKey(event: any) {
      this.key = event.code;
    },

    automaticSearch() {
      this.stopTimer();
      const trimmedFilterInput = this.filterInput.replace(/\s/g, "");

      if (trimmedFilterInput.length === 0) {
        this.stopTimer();
        return;
      }

      if (this.key === "Enter" || this.timerStopped === true) {
        this.timerStopped = false;
        this.stopTimer();
        this.getData({
          pagination: this.pagination,
          filter: undefined
        });
        return;
      }
      const intervalTime = 100;
      this.intervalId = setInterval(this.changeProgress, intervalTime);
    },

    filterUsersSelect(val: any, update: any) {
      update(() => {
        const needle = val.toLowerCase();
        this.dataSelectUsersFiltered = this.dataSelectUsers.filter(
          (v: { username: string }) =>
            v.username.toLowerCase().indexOf(needle) > -1
        );
      });
    },

    filterProduttoriSelect(val: any, update: any) {
      update(() => {
        const needle = val.toLowerCase();
        this.dataSelectProduttoriFiltered = this.dataSelectProduttori.filter(
          (v: { description: string }) =>
            v.description.toLowerCase().indexOf(needle) > -1
        );
      });
    },

    async getUsers() {
      const listaUsers = (await Api.customers.getAllUsers()) as any;
      for (let i = 0; i < listaUsers.length; i++) {
        if (listaUsers[i].roleId === 3) {
          this.dataSelectUsers.push({
            id: listaUsers[i].id,
            username: `${listaUsers[i].username} - ${listaUsers[i].producerCode}`
          });
        }
      }
    },
    async getCustomerDescription() {
      const listaProduttori = (await Api.customers.getAllProducers()) as any;
      for (let i = 0; i < listaProduttori.length; i++) {
        this.dataSelectProduttori.push({
          producerCode: listaProduttori[i].producer_code,
          description: `${listaProduttori[i].producer_code} -
            ${listaProduttori[i].description}`
        });
      }
    },
    clearFilters() {
      this.numeroFiltri = 0;
      this.toggleButtonInAttesa = false;
      this.toggleButtonDocumentiAutoApprovati = false;
      this.filter = "";
      this.toggleButtonSubProducers = false;
      this.ToggleButtonCompliant = false;
      this.ToggleButtonNonCompliant = false;
      this.dataCopliantDa = null;
      this.dataCopliantA = null;
      this.dataUploadDa = null;
      this.dataUploadA = null;
      this.filtraClientiPerUtente = null;
      this.filtraClientiPerProduttore = null;
      this.getData({ pagination: this.pagination, filter: undefined });
    },
    toggleFilter() {
      return (this.isShow = !this.isShow);
    },
    isDemo() {
      return true;
    },
    formatDate(value: any) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    isComplianceStatus(obj: any) {
      return obj.compliance && obj.code !== "CA";
    },
    isComplianceWarningStatus(obj: any) {
      return obj.code === "CA";
    },
    isWaitingStatus(obj: any) {
      return (
        obj.code === "FC" ||
        obj.code === "SS" ||
        obj.code === "AC" ||
        obj.code === "VC"
      );
    },
    getAllowReceiveEmail(obj: any) {
      return obj.allow_receive_email == null ? true : obj.allow_receive_email;
    },
    setStatusIcon(objStatus: any, slug: any, block: any) {
      if (this.isComplianceStatus(objStatus)) {
        return (
          "/img/icons/documents/" +
          slug +
          "_green" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      } else if (this.isWaitingStatus(objStatus)) {
        return (
          "/img/icons/documents/" +
          slug +
          "_yellow" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      } else if (this.isComplianceWarningStatus(objStatus)) {
        return (
          "/img/icons/documents/" +
          slug +
          "_green_warn" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      } else {
        return (
          "/img/icons/documents/" +
          slug +
          "_red" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      }
    },
    openCheckAllDocuments(customer: any) {
      this.openCheckAllDocumentsModal = true;
      this.customerId = customer.id;
    },
    editCustomer(customer: any) {
      window.location.href = "/customer/" + customer.id;
    },
    async getData(props: any) {
      const { rowsPerPage } = props.pagination;
      this.loading = true;
      this.timerSearch = 0;
      // this.filtraClientiPerProduttore = props.filtraClientiPerProduttore;

      if (this.filtraClientiPerUtente != null) {
        this.filtraClientiPerProduttore = null;
      }

      // fetch data from "server"
      // const returnedData = this.fetchFromServer(startRow, fetchCount, filter, sortBy, descending);
      const returnedData = (await Api.customers.getFilteredDataAsync(
        props.pagination.page,
        props.pagination.rowsPerPage > 0
          ? props.pagination.rowsPerPage
          : props.pagination.rowsNumber,
        this.filterInput,
        this.ToggleButtonCompliant,
        this.ToggleButtonNonCompliant,
        this.toggleButtonInAttesa,
        this.filtraClientiPerProduttore,
        this.dataUploadDa,
        this.dataUploadA,
        this.dataCopliantDa,
        this.dataCopliantA,
        this.filtraClientiPerUtente,
        this.toggleButtonDocumentiAutoApprovati,
        this.toggleButtonSubProducers
      )) as any;

      this.filter = this.filterInput;

      this.data = returnedData.data;

      this.totalRows = returnedData.count;

      this.page = returnedData.current_page;

      // update rowsCount with appropriate value
      this.pagination.rowsNumber = this.getRowsNumberCount();

      // clear out existing data and add new
      this.data.splice(0, this.data.length, ...this.data);

      // don't forget to update local pagination object
      this.pagination.page = returnedData.current_page;
      this.pagination.rowsPerPage = rowsPerPage;

      // ...and turn of loading indicator
      this.loading = false;

      this.loaded = true;
      this.timerStopped = false;
    },
    getRowsNumberCount() {
      return this.totalRows;
    }
  }
});
